import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const TagGift = ({size, fill, className, id, text}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"40"} height={"40"}/>
      <g id="TagGift">
        <path d="M47.448,3.126c0,-0.989 -0.803,-1.793 -1.793,-1.793l-43.31,0c-0.99,0 -1.793,0.804 -1.793,1.793l0,41.748c0,0.989 0.803,1.793 1.793,1.793l43.31,0c0.99,0 1.793,-0.804 1.793,-1.793l0,-41.748Z" fill={fill} />
        <path d="M14.294,28.83l4.869,0l0,6.366c-0.726,0.242 -1.472,0.423 -2.229,0.541c-0.707,0.104 -1.421,0.157 -2.137,0.156c-1.584,0.105 -3.136,-0.493 -4.241,-1.634c-1.056,-1.325 -1.578,-2.999 -1.464,-4.689c-0.101,-1.712 0.514,-3.391 1.697,-4.632c1.283,-1.165 2.983,-1.765 4.713,-1.665c1.257,-0.002 2.5,0.255 3.652,0.755l-0.872,2.082c-0.867,-0.441 -1.825,-0.671 -2.797,-0.672c-1.024,-0.042 -2.015,0.374 -2.703,1.133c-0.711,0.852 -1.074,1.941 -1.016,3.049c-0.071,1.08 0.218,2.154 0.823,3.053c0.575,0.716 1.464,1.109 2.38,1.053c0.556,-0.001 1.11,-0.057 1.654,-0.167l0,-2.562l-2.329,0l0,-2.167Zm22.334,-2.485l2.627,0l0,1.923l-2.627,0l0,4.533c-0.024,0.302 0.091,0.599 0.312,0.807c0.231,0.173 0.516,0.258 0.804,0.24c0.549,-0.017 1.092,-0.116 1.611,-0.294l0,1.909c-0.743,0.305 -1.541,0.451 -2.344,0.428c-0.823,0.073 -1.639,-0.212 -2.237,-0.781c-0.516,-0.661 -0.767,-1.489 -0.707,-2.325l0,-4.533l-1.225,0l0,-1.083l1.406,-0.857l0.74,-1.982l1.64,0l0,2.015Zm-12.182,9.379l-2.563,0l0,-9.379l2.563,0l0,9.379Zm5.651,0l-2.553,0l0,-7.464l-1.407,0l0,-1.235l1.407,-0.688l0,-0.688c-0.079,-0.856 0.205,-1.707 0.781,-2.345c0.72,-0.555 1.623,-0.819 2.528,-0.739c0.808,-0.014 1.611,0.12 2.37,0.397l-0.655,1.876c-0.461,-0.153 -0.942,-0.236 -1.427,-0.244c-0.297,-0.025 -0.589,0.096 -0.782,0.324c-0.17,0.241 -0.256,0.532 -0.244,0.827l0,0.6l2.206,0l0,1.915l-2.224,0l0,7.464Zm-8.321,-11.813c0,-0.834 0.464,-1.251 1.394,-1.251c0.93,0 1.394,0.417 1.394,1.251c0.021,0.345 -0.106,0.682 -0.348,0.928c-0.293,0.242 -0.668,0.361 -1.046,0.332c-0.93,0 -1.394,-0.42 -1.394,-1.26Zm-6.061,-10.5l3.833,0l0,2.173l-3.833,0l0,3.82l-2.189,0l0,-3.822l-3.833,0l0,-2.173l3.833,0l0,-3.869l2.189,0l0,3.871Z" fill={text} />
      </g>
    </svg>
  );
};

TagGift.defaultProps = {
  size: 48,
  fill: "#fff",
  text: "#f00",
  className: "",
  id: ""
};

TagGift.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
